module.exports = __webpack_public_path__ + "static/media/29BDOS25.59b623d5.jpg";